import { Component, OnDestroy, OnInit, Output, Input, EventEmitter, ViewEncapsulation } from '@angular/core';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { Validators, Editor, Toolbar, toHTML, toDoc } from 'ngx-editor';

@Component({
  selector: 'rich-text-editor',
  templateUrl: 'rich-text-editor.component.html',
  styleUrls: ['./rich-text-editor.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class RichTextEditorComponent implements OnInit, OnDestroy {
  editordoc = {};

  @Input()
  html: string;

  @Output()
  htmlChange: EventEmitter<string> = new EventEmitter<string>();

  htmlDoc: any;

  editor: Editor;
  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'strike'],
    ['code', 'blockquote'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['link', 'image'],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];

  form = new FormGroup({
    editorContent: new FormControl(
      { value: null, disabled: false },
      Validators.required()
    ),
  });

  get doc(): AbstractControl {
    return this.form.get('editorContent');
  }

  ngOnInit(): void {
    this.htmlDoc = toDoc(this.html);

    this.form.controls.editorContent.setValue(this.htmlDoc);

    this.form.controls.editorContent.valueChanges.subscribe(htmlDoc => {
      const html = toHTML(htmlDoc);
      this.htmlChange.emit(html);
    });

    this.editor = new Editor();
  }

  ngOnDestroy(): void {
    this.editor.destroy();
  }
}
